import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CheckmarkIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.checkmarkIcon}`}
        data-testid={testId}
        fill='none'
        height='10'
        viewBox='0 0 14 10'
        width='14'
        xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M11.8291 0.496094C12.1268 0.195153 12.5941 0.170778 12.9199 0.421875H12.9336L13.0078 0.496094C13.3309 0.822804 13.3303 1.35019 13.0068 1.67676L13.0078 1.67773L5.2666 9.50391C5.10465 9.66764 4.8907 9.75 4.67773 9.75C4.46436 9.75 4.25195 9.66768 4.08984 9.50488L4.08887 9.50391L0.992188 6.37305C0.669251 6.04612 0.669274 5.51781 0.993164 5.19141C1.31803 4.86359 1.84464 4.86353 2.16895 5.19238L4.67578 7.72754L11.8291 0.496094Z'
            fill='currentColor'
            stroke='currentColor'
            strokeWidth='0.5'
        />
    </svg>
);

export default CheckmarkIcon;
